import { FormProvider, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import { Stack } from "@mui/material";
import {
  OnboardingStepLayout,
  EmailInput,
  TextInput,
  PhoneInput,
} from "./../../../shared/ui/index";
import { Step3Schema, type Step3Input } from "../../../shared/schemas/step3";
import { useTranslation } from "react-i18next";

export type Step3FormValues = Step3Input;

type Step3Props = {
  currentStep: number;
  totalSteps: number;
  initialValues?: Step3FormValues;
  onCompleted: (data: Step3FormValues) => void;
  onBack: () => void;
};

export default function Step3_FleetManager({
  currentStep,
  totalSteps,
  initialValues,
  onCompleted,
  onBack,
}: Step3Props) {
  const methods = useForm<Step3FormValues>({
    resolver: zodResolver(Step3Schema),
    defaultValues:
      initialValues ??
      ({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
      } as Step3FormValues),
  });

  const { handleSubmit } = methods;
  const { t } = useTranslation();

  const onSubmit = handleSubmit((data) => {
    sessionStorage.setItem("step3", JSON.stringify(data));
    onCompleted(data);
  });

  return (
    <FormProvider {...methods}>
      <OnboardingStepLayout
        step={currentStep}
        totalSteps={totalSteps}
        title={t("onboarding.step3FleetManager.title")}
        subtitle=""
        onNext={onSubmit}
        nextLabel={t("onboarding.step3FleetManager.actions.next")}
        onBack={onBack}
        backLabel={t("onboarding.step3FleetManager.actions.back")}
      >
        <Stack spacing={2.5}>
          <TextInput<Step3FormValues, "firstName">
            name="firstName"
            label={t("onboarding.step1.firstName.label")}
            placeholder={t("onboarding.step1.firstName.placeholder")}
            required
          />

          <TextInput<Step3FormValues, "lastName">
            name="lastName"
            label={t("onboarding.step1.lastName.label")}
            placeholder={t("onboarding.step1.lastName.placeholder")}
            required
          />

          <PhoneInput<Step3FormValues, "phone">
            name="phone"
            label={t("onboarding.step1.phone.label")}
            required
          />

          <EmailInput<Step3FormValues, "email">
            name="email"
            label={t("onboarding.step1.email.label")}
            placeholder={t("onboarding.step1.email.placeholder")}
            required
          />
        </Stack>
      </OnboardingStepLayout>
    </FormProvider>
  );
}
